import React, { useState, useEffect } from 'react'
import { Grid, Typography, FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core'

function VariantCallingFilterModal({ value = null, onChange, onClose }) {
  // Convert value to valid radio value
  const convertToRadioValue = (val) => {
    if (val === 'PASS') return 'PASS'
    if (val === 'FAIL') return 'FAIL'
    return 'PASS' // default
  }

  const [localValue, setLocalValue] = useState(convertToRadioValue(value))

  // Update local state when prop changes
  useEffect(() => {
    setLocalValue(convertToRadioValue(value))
  }, [value])

  console.log('VariantCallingFilterModal received value:', value, 'localValue:', localValue)

  const handleChange = (event) => {
    const newValue = event.target.value
    console.log('Variant Calling filter changed locally:', newValue)
    setLocalValue(newValue)
    onChange(newValue)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Variant Calling Filter
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Select variant calling filter status.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            value={localValue !== null && localValue !== undefined ? localValue : 'PASS'}
            onChange={handleChange}
          >
            <FormControlLabel value="PASS" control={<Radio />} label="PASS" />
            <FormControlLabel value="FAIL" control={<Radio />} label="FAIL" />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  )
}

export default VariantCallingFilterModal
